import Badge from '@ingka/badge';
import Text from '@ingka/text';
import { translate } from '@repo/phrase';

import styles from './styles.module.scss';

interface Props {
    title?: string | undefined;
    description?: string | undefined;
    isReferenceItem?: boolean | undefined;
}

export const ArticleTitleDescription = ({ title, description, isReferenceItem }: Props) => {
    return (
        <div className={styles.article_title_description}>
            {title && (
                <Text tagName="span" textStyle="Label.M">
                    {title}
                </Text>
            )}
            {description && (
                <Text tagName="span" textStyle="Body.M" className={styles.description ?? ''}>
                    {description}
                </Text>
            )}
            {isReferenceItem && <Badge label={translate('badge_label_reference')} colour="black" size="small" />}
        </div>
    );
};
